import { createBrowserRouter } from "react-router-dom";
import Dashboard from "../pages/dashboard/Dashboard";
import App from "../App";
// import Home from "../pages/home/Home";
// import Profile from "../pages/profile/Profile";
import Addresses from "./../pages/addresses/Addresses";
// import AddressAugmont from "../pages/addressAugmont/AddressAugmont";
// import BankAugmonts from "./../pages/bankAugmonts/BankAugmonts";
import Banks from "./../pages/banks/Banks";
// import BuyAugmonts from "./../pages/buyAugmonts/BuyAugmonts";
// import BuyInvoices from './../pages/buyInvoices/BuyInvoices';
// import BuyReqAugmonts from "./../pages/buyReqAugmonts/BuyReqAugmonts";
// import BuyandTransfers from "./../pages/buyAndTransfers/BuyandTransfers";
import Cities from "./../pages/cities/Cities";
import Login from "../pages/login/Login";
// import Users from "../pages/users/Users";
import User from "../pages/users/User";
// import Aadhar from "./../pages/aadhar/Aadhar";
import Transection from "../pages/transection/Transection";
import Proposal from "../pages/proposal/Proposal";
import PartnerRegister from "../pages/partner_register/PartnerRegister";
import LoginTable from "../pages/login_table/LoginTable";
import Employee from "../pages/employee/Employee";
// import Clients from "../pages/clients/Clients";
import SellRequest from "../pages/sell_request/SellRequest";
import BuyInvoice from "../pages/buy_Invoice/BuyInvoice";
// import RedeemInvoice from "../pages/redeemInvoice/RedeemInvoice";
import SellInvoice from "../pages/sell_Invoice/SellInvoice";
import Mandate from "../pages/mandate/Mandate";
import Sip from "../pages/sip/Sip";
import Order from "../pages/order/Order";
// import UserAugmont from "../pages/user_augmont/UserAugmont";
// import WithdrawAugmont from "../pages/withdraw_augmont/WithdrawAugmont";
// import StateAugmont from "../pages/state_augmont/StateAugmont";
// import Settings from "../pages/settings/Settings";
import Queries from "./../pages/queries/Queries";
// import State from "../pages/state/State";
// import Transfer from "../pages/transfer/Transfer";
// import Referral from "../pages/referral/Referral";
// import Preference from "../pages/preference/Preference";
import Pan from "../pages/pan/Pan";
import Nominee from "../pages/nominee/Nominee";
// import MmtcSellResponse from "../pages/mmtcSellResponse/MmtcSellResponse";
// import MmtcSellRequest from "../pages/mmtcSellRequest/MmtcSellRequest";
import MmtcRedeem from "../pages/MmtcRedeem/MmtcRedeem";
// import Mmtc_buy_response from "../pages/mmtc_buy_response/Mmtc_buy_response";
// import Mmtc_buy_requests from "../pages/mmtc_buy_request/Mmtc_buy_request";
// import Logs from "../pages/Logs/Logs";
// import Kyc from "../pages/kyc/Kyc";
// import InitiateConfirmTransfer from "../pages/initiateConfirmTransfer/InitiateConfirmTransfer";
// import Countries from "../pages/countries/Countries";
import RequireAuth from "./RequireAuth";
import RequireNoAuth from "./RequireNoAuth";
// import Devices from "../pages/devices/Devices";
import Sell_Augmont from "../pages/sell_Augmont/Sell_Augmont";
import Redeems from "../pages/redeems/Redeems";
import BuyRequests from "../pages/buy_requests/BuyRequests";
// import ClientKyc from "../pages/client_kyc/ClientKyc";
// import ClientBuy from "../pages/client_buy/ClientBuy";
import SendNotification from "../components/customTable/SendNotification";
// import EditUser from "../pages/users/EditUser";
import ResetPassword from "../pages/resetPassword/ResetPassword";
import MobileCrousal from "../pages/mobileCrousal/MobileCrousal";
import WebCarousal from "../pages/mobileCrousal/WebCarousal";
import PartnerNotification from "../components/customTable/PartnerNotification";
import JewelleryCatalogue from "../pages/jewelleryCatalogue/JewelleryCatalogue";
// import RequireAuth from "./RequireAuth";
import Cart from "./../pages/cart/Cart";
import Checkout from "../pages/checkout/Checkout";
import Blog from "../pages/blog/Blog";
// import HistoryPortfolio from "../pages/history/History";
// import HistoryInvoice from "../pages/history/HistoryInvoice";
import { Roles } from "../pages/Roles/Roles";
import ProtectedRoute from "./ProtectedRoute";
// import HelpAndSupport from "../pages/helpAndSupport/HelpAndSupport";
// import AllPayments from "../pages/allPayments/AllPayments";
// import RefundPayment from "../pages/RefundPayment/RefundPayment";
// import XlsxReader from "../pages/xlsxReader/XlsxReader";
// import ImportPartner from "../pages/importPartner/ImportPartner";
import BatukPartner from "../pages/batukPartner/batukPartner";
import NotFound from "../pages/notFound/NotFound";
import PartnerReportCard from "../pages/partnerReportCard/PartnerReportCard";
// import WhatsAppChat from "./../pages/whatsApp/WhatsAppChat";
// import WhatsAppChat from "../pages/whatsApp/WhatsAppChat";
import DigitalGold from "../pages/digitalGold/DigitalGold";
import OrderSummary from "../pages/digitalGold/OrderSummary";
import FintsoTransactions from "../pages/fintsoTransactions/FintsoTransactions";
// import Buy from "../pages/fintsoTransactions/Buy";
// import Sell from "../pages/fintsoTransactions/Sell";
// import Redeem from "../pages/fintsoTransactions/Redeem";
// import Spot from "../pages/fintsoTransactions/Spot";
import SipMining from "../pages/reports/sipMining/SipMining";
import ComplianceReport from "../pages/reports/compliance/ComplianceReport";
import InactiveClients from "../pages/reports/inactiveClient/InactiveClients";
import FileImportHistory from "../pages/reports/fileImport/FileImportHistory";
import SipBusinessReport from "../pages/reports/sipBussiness/SipBusinessReport";
import MissingSip from "../pages/reports/missingSip/MissingSip";
import UserProfile from "../pages/UserProfile";
import BuyResponse from "../pages/buy_response/BuyResponse";
// import UserAugmont from "../pages/user_augmont/UserAugmont";
import PartnerInvoice from "../pages/partnerInvoice/PartnerInvoice";
import TemplateCreation from "../pages/templateCreation/TemplateCreation";
import SpotGoldQueries from "../pages/spotGoldQueries/SpotGoldQueries";
// import MaintenanceSetting from "../pages/maintenance setting/MaintenanceSetting";
import Mmtc from "../pages/mmtc/Mmtc";
// import PartnerMaintenanceSetting from "../pages/partnerMaintenanceSetting/PartnerMaintenanceSetting";
// import RefundRequest from "../pages/redundRequest/RefundRequest";
import UpdateKycTab from "../pages/kycUpdate/UpdateKycTab";
import Lumpsum from "../pages/reports/lumpsum/Lumpsum";
import SipBooking from "../pages/reports/sipBooking/SipBooking";
// import CollateralTab from "../pages/collateral_upload/CollateralTab";
import PartnerCommission from "../pages/partnerCommissionReport/PartnerCommission";
import MFD from "../pages/MFD/MFD";
import MediaCoverageTab from "../pages/mediaCoverage/MediaCoverageTab";
import CollateralUpload from "../pages/collateral_upload/CollateralUpload";
import HomeBanner from "../pages/homeBanner/HomeBanner";
// import ActivePartner from "../pages/partnerReportCard/ActivePartner";
// import InactivePartner from "../pages/partnerReportCard/InactivePartner";
import ActiveInactiveTab from "../pages/partnerReportCard/ActiveInactiveTab";
import PartnerTransactionTab from "../pages/partnerReportCard/PartnerTransactionTab";
import PartnerTransactionReportTab from "../pages/partnerReportCard/PartnerTransactionReportTab";
// import UserList from "../pages/users/UserList";
// import CredentialsSent from "../pages/credentialsSent/CredentialsSent";
// import RewardSystem from './../pages/rewardSystem/RewardSystem';
import GiftCard from "../pages/giftCard/GiftCard";
import Policy from "../pages/policy/Policy";
import Faq from "../pages/faq/Faq";
// import Gst from "../pages/gst/Gst";
import Dsr from "../pages/dsr report/Dsr";
import SalesTarget from "../pages/salesTarget/SalesTarget";
import GiftCardUser from "../pages/giftCardUser/GiftCardUser";
import BajajDashboard from "../pages/dashboard/dashboard_data/BajajDashboard";
import Mmtc_buy_request from "../pages/mmtc/Mmtc_buy_request";
import Mmtc_buy_response from "../pages/mmtc/Mmtc_buy_response";
import MmtcSellRequest from "../pages/mmtc/MmtcSellRequest";
import MmtcSellResponse from "../pages/mmtc/MmtcSellResponse";
import Mmtc_redeem from "../pages/mmtc/Mmtc_redeem";
import SellQuoteMmtc from "../pages/SellQuoteMmtc";
import TradeFailed from "../pages/TradeFailed";
import SendRepo from "../pages/SendReport/SendRepo";
import Kycnamemismatch from "../pages/KycNameMismatch";
import ParnterViewDetail from "../pages/partner_register/ParnterViewDetail";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    ),
    children: [
      {
        index: true,
        element: <App />,
      },

      {
        path: "*",
        element: <NotFound />,
      },

      {
        path: "/BajajDashboard",
        element: (
          <ProtectedRoute permissionKey="BajajDashboard">
            <BajajDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/sendnotification",
        element: (
          <ProtectedRoute permissionKey="Notification">
            <SendNotification />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/partnernotification",
      //   element: (
      //     <ProtectedRoute permissionKey="PartnerNotification">
      //       <PartnerNotification />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/helpandsupport",
      //   element: (
      //     <ProtectedRoute permissionKey="HelpAndSupport">
      //       <HelpAndSupport />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/profile",
      //   element: <Profile />, // No specific permission required here
      // },
      // {
      //   path: "/home",
      //   element: <Home />, // No specific permission required here
      // },
      // {
      //   path: "/aadhar",
      //   element: (
      //     <ProtectedRoute permissionKey="Aadhar">
      //       <Aadhar />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/address_augmonts",
      //   element: (
      //     <ProtectedRoute permissionKey="AddressAugmont">
      //       <AddressAugmont />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/addresses",
        element: (
          <ProtectedRoute permissionKey="Address">
            <Addresses />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/bank_augmonts",
      //   element: (
      //     <ProtectedRoute permissionKey="BankAugmont">
      //       <BankAugmonts />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/banks",
        element: (
          <ProtectedRoute permissionKey="Banks">
            <Banks />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/buy_augmonts",
      //   element: (
      //     <ProtectedRoute permissionKey="BuyAugmont">
      //       <BuyAugmonts />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/buy_invoices",
        element: (
          <ProtectedRoute permissionKey="BuyInvoice">
            <BuyInvoice />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/buy_req_augmonts",
      //   element: (
      //     <ProtectedRoute permissionKey="BuyReqAugmont">
      //       <BuyReqAugmonts />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/buy_requests",
        element: (
          <ProtectedRoute permissionKey="BuyRequest">
            <BuyRequests />
          </ProtectedRoute>
        ),
      },
      {
        path: "/buy_response",
        element: (
          <ProtectedRoute permissionKey="BuyResponse">
            <BuyResponse />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/buyandtransfers",
      //   element: <BuyandTransfers />,
      // },
      // {
      //   path: "/cities",
      //   element: (
      //     <ProtectedRoute permissionKey="Cities">
      //       <Cities />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/users",
      //   element: <Users />,
      // },
      {
        path: "/users",
        element: (
          <ProtectedRoute permissionKey="User">
            <User />
          </ProtectedRoute>
        ),
      },
      {
        path: "/view_detail/:id",
        element: (
          <ProtectedRoute permissionKey="User">
            <ParnterViewDetail />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/credentials_sent",
      //   element: (
      //     <ProtectedRoute permissionKey="credentials_sent">
      //       <CredentialsSent />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/userList",
      //   element: (
      //     <ProtectedRoute permissionKey="userList">
      //       <UserList />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/edit-user/:id",
      //   element: <EditUser />,
      // },
      {
        path: "/transactions",
        element: (
          <ProtectedRoute permissionKey="Transactions">
            <Transection />
          </ProtectedRoute>
        ),
      },
      {
        path: "/proposals",
        element: (
          <ProtectedRoute permissionKey="Proposals">
            <Proposal />
          </ProtectedRoute>
        ),
      },
      {
        path: "/partner_registerations",
        element: (
          <ProtectedRoute permissionKey="PartnerRegisterations">
            <PartnerRegister />
          </ProtectedRoute>
        ),
      },
      {
        path: "/login_tables",
        element: (
          <ProtectedRoute permissionKey="LoginTables">
            <LoginTable />
          </ProtectedRoute>
        ),
      },
      {
        path: "/employees",
        element: (
          <ProtectedRoute permissionKey="Employees">
            <Employee />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/clients",
      //   element: (
      //     <ProtectedRoute permissionKey="Clients">
      //       <Clients />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/sell_requests",
        element: (
          <ProtectedRoute permissionKey="SellRequests">
            <SellRequest />
          </ProtectedRoute>
        ),
      },

      // {
      //   path: "/redeem_Invoices",
      //   element: <RedeemInvoice />,
      // },
      // {
      //   path: "/sell_invoices",
      //   element: (
      //     <ProtectedRoute permissionKey="SellInvoices">
      //       <SellInvoice />
      //     </ProtectedRoute>
      //   ),
      // },

      {
        path: "/sell_response",
        element: (
          <ProtectedRoute permissionKey="SellInvoices">
            <SellInvoice />
          </ProtectedRoute>
        ),
      },
      {
        path: "/mandate",
        element: (
          <ProtectedRoute permissionKey="Mandates">
            <Mandate />
          </ProtectedRoute>
        ),
      },
      {
        path: "/sip",
        element: (
          <ProtectedRoute permissionKey="Sip">
            <Sip />
          </ProtectedRoute>
        ),
      },
      {
        path: "/order",
        element: (
          <ProtectedRoute permissionKey="Order">
            <Order />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/user_augmonts",
      //   element: (
      //     <ProtectedRoute permissionKey="userAugmonts">
      //       <UserAugmont />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/user_augmonts",
      //   element: <UserAugmont />,
      // },
      // {
      //   path: "/withdraw_augmonts",
      //   element: <WithdrawAugmont />,
      // },
      // {
      //   path: "/state_augmonts",
      //   element: <StateAugmont />,
      // },
      // {
      //   path: "/settings",
      //   element: (
      //     <ProtectedRoute permissionKey="Settings">
      //       <Settings />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/MaintenanceSetting",
      //   element: (
      //     <ProtectedRoute permissionKey="MaintenanceSetting">
      //       <MaintenanceSetting />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/PartnerMaintenanceSetting",
      //   element: (
      //     <ProtectedRoute permissionKey="PartnerMaintenanceSetting">
      //       <PartnerMaintenanceSetting />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/queries",
        element: (
          <ProtectedRoute permissionKey="Queries">
            <Queries />
          </ProtectedRoute>
        ),
      },
      {
        path: "/SpotGoldQueries",
        element: (
          <ProtectedRoute permissionKey="SpotGoldQueries">
            <SpotGoldQueries />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/states",
      //   element: (
      //     <ProtectedRoute permissionKey="States">
      //       <State />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/transfers",
      //   element: <Transfer />,
      // },
      // {
      //   path: "/referrals",
      //   element: (
      //     <ProtectedRoute permissionKey="Referrals">
      //       <Referral />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/preferences",
      //   element: <Preference />,
      // },
      {
        path: "/pans",
        element: (
          <ProtectedRoute permissionKey="Pan">
            <Pan />
          </ProtectedRoute>
        ),
      },
      {
        path: "/nominees",
        element: (
          <ProtectedRoute permissionKey="Nominees">
            <Nominee />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/mmtc_sell_responses",
      //   element: <MmtcSellResponse />,
      // },
      // {
      //   path: "/mmtc_sell_requests",
      //   element: <MmtcSellRequest />,
      // },
      // {
      //   path: "/mmtc_redeems",
      //   element: <MmtcRedeem />,
      // },
      // {
      //   path: "/mmtc_buy_response",
      //   element: (
      //     <ProtectedRoute permissionKey="mmtc_buy_response">
      //       <Mmtc_buy_response />,

      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/mmtc_buy_response",
      //   element: <Mmtc_buy_response />,
      // },
      // {
      //   path: "/mmtc_buy_requests",
      //   element: <Mmtc_buy_requests />,
      // },
      // {
      //   path: "/logs",
      //   element: <Logs />,
      // },
      // {
      //   path: "/kycs",
      //   element: <Kyc />,
      // },
      // {
      //   path: "/initiateconfirmtransfers",
      //   element: <InitiateConfirmTransfer />,
      // },
      // {
      //   path: "/countries",
      //   element: (
      //     <ProtectedRoute permissionKey="Countries">
      //       <Countries />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/devices",
      //   element: <Devices />,
      // },
      // {
      //   path: "/sell_augmonts",
      //   element: (
      //     <ProtectedRoute permissionKey="SellAugmonts">
      //       <Sell_Augmont />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/redeems",
        element: (
          <ProtectedRoute permissionKey="Redeems">
            <Redeems />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/client_kyc",
      //   element: (
      //     <ProtectedRoute permissionKey="ClientKyc">
      //       <ClientKyc />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/client_buy",
      //   element: (
      //     <ProtectedRoute permissionKey="ClientBuy">
      //       <ClientBuy />
      //     </ProtectedRoute>
      //   ),
      // },

      {
        path: "/resetpassword",
        element: <ResetPassword />,
      },
      {
        path: "/app_banner",
        element: (
          <ProtectedRoute permissionKey="AppBanner">
            <MobileCrousal />
          </ProtectedRoute>
        ),
      },
      {
        path: "/web_banner",
        element: (
          <ProtectedRoute permissionKey="WebBanner">
            <WebCarousal />
          </ProtectedRoute>
        ),
      },
      {
        path: "/jewellery_catalogue",
        element: (
          <ProtectedRoute permissionKey="JewelleryCatalogue">
            <JewelleryCatalogue />
          </ProtectedRoute>
        ),
      },
      {
        path: "/cart",
        element: <Cart />,
      },
      {
        path: "/checkout",
        element: <Checkout />,
      },
      {
        path: "/blog",
        element: (
          <ProtectedRoute permissionKey="Blog">
            <Blog />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/RefundReq",
      //   element: (
      //     <ProtectedRoute permissionKey="RefundReq">
      //       <RefundRequest />
      //       {/* <XlsxReader /> */}
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/history",
      //   element: <HistoryPortfolio />,
      // },
      // {
      //   path: "/historyinvoice",
      //   element: <HistoryInvoice />,
      // },
      // {
      //   path: "/AllPayments",
      //   element: (
      //     <ProtectedRoute permissionKey="AllPayments">
      //       <AllPayments />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/RefundPayment",
      //   element: (
      //     <ProtectedRoute permissionKey="RefundPayment">
      //       <RefundPayment />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/ImportPartner",
      //   element: (
      //     <ProtectedRoute permissionKey="ImportPartner">
      //       <ImportPartner />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/role",
        element: (
          <ProtectedRoute permissionKey="Role">
            <Roles />
          </ProtectedRoute>
        ),
      },
      {
        path: "/BatukPartner",
        element: (
          <ProtectedRoute permissionKey="BatukPartner">
            <BatukPartner />
          </ProtectedRoute>
        ),
      },
      {
        path: "/PartnerReport",
        element: (
          <ProtectedRoute permissionKey="PartnerReport">
            <PartnerReportCard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/PartnerReport",
        element: (
          <ProtectedRoute permissionKey="PartnerReport">
            <PartnerReportCard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/ActivePartner",
        element: (
          <ProtectedRoute permissionKey="ActivePartner">
            <ActiveInactiveTab />
          </ProtectedRoute>
        ),
      },
      {
        path: "/PartnerTransaction",
        element: (
          <ProtectedRoute permissionKey="PartnerTransaction">
            <PartnerTransactionTab />
          </ProtectedRoute>
        ),
      },
      {
        path: "/DistributorReport",
        element: (
          <ProtectedRoute permissionKey="DistributorReport">
            <PartnerTransactionReportTab />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/InactivePartner",
      //   element: (
      //     <ProtectedRoute permissionKey="InactivePartner">
      //       <InactivePartner />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "/WhatsAppChat",
      //   element: (
      //     <ProtectedRoute permissionKey="WhatsAppChat">
      //       <WhatsAppChat />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/DigitalGold",
        element: (
          <ProtectedRoute permissionKey="DigitalGold">
            <DigitalGold />
          </ProtectedRoute>
        ),
      },
      {
        path: "/kycUpdate",
        element: (
          <ProtectedRoute permissionKey="kycUpdate">
            <UpdateKycTab />
          </ProtectedRoute>
        ),
      },
      {
        path: "/fintsoTransactions",
        element: (
          <ProtectedRoute permissionKey="fintsoTransactions">
            <FintsoTransactions />
          </ProtectedRoute>
        ),
      },

      {
        path: "/OrderSummary/:id/:data",
        element: <OrderSummary />,
      },
      {
        path: "/Lumpsum",
        element: (
          <ProtectedRoute permissionKey="Lumpsum">
            <Lumpsum />
          </ProtectedRoute>
        ),
      },
      {
        path: "/SipBooked",
        element: (
          <ProtectedRoute permissionKey="SipBooked">
            <SipBooking />
          </ProtectedRoute>
        ),
      },
      {
        path: "/SIPMining",
        element: (
          <ProtectedRoute permissionKey="SIPMining">
            <SipMining />
          </ProtectedRoute>
        ),
      },
      {
        path: "/ComplianceReport",
        element: (
          <ProtectedRoute permissionKey="ComplianceReport">
            <ComplianceReport />
          </ProtectedRoute>
        ),
      },
      {
        path: "/InactiveClient",
        element: (
          <ProtectedRoute permissionKey="InactiveClient">
            <InactiveClients />
          </ProtectedRoute>
        ),
      },
      {
        path: "/FileImportHistory",
        element: (
          <ProtectedRoute permissionKey="FileImportHistory">
            <FileImportHistory />
          </ProtectedRoute>
        ),
      },
      {
        path: "/SIPBussinessReport",
        element: (
          <ProtectedRoute permissionKey="SIPBussinessReport">
            <SipBusinessReport />
          </ProtectedRoute>
        ),
      },
      {
        path: "/MissingSIP",
        element: (
          <ProtectedRoute permissionKey="MissingSIP">
            <MissingSip />
          </ProtectedRoute>
        ),
      },
      {
        path: "/PartnerInvoice",
        element: (
          <ProtectedRoute permissionKey="PartnerInvoice">
            <PartnerInvoice />
          </ProtectedRoute>
        ),
      },
      {
        path: "/partnerCommisssionReport",
        element: (
          <ProtectedRoute permissionKey="partnerCommisssionReport">
            <PartnerCommission />
          </ProtectedRoute>
        ),
      },
      {
        path: "/mutualFund",
        element: (
          <ProtectedRoute permissionKey="mutualFund">
            <MFD />
          </ProtectedRoute>
        ),
      },
      {
        path: "/TemplateCreation",
        element: (
          <ProtectedRoute permissionKey="TemplateCreation">
            <TemplateCreation />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/Mmtc",
      //   element: (
      //     <ProtectedRoute permissionKey="Mmtc">
      //       <Mmtc />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/CollateralUpload",
        element: (
          <ProtectedRoute permissionKey="CollateralUpload">
            <CollateralUpload />
            {/* <CollateralTab/> */}
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/MediaCoverage",
      //   element: (
      //     <ProtectedRoute permissionKey="MediaCoverage">
      //       <MediaCoverageTab />
      //     </ProtectedRoute>
      //   ),
      // },

      {
        path: "/HomeBanner",
        element: (
          <ProtectedRoute permissionKey="HomeBanner">
            <HomeBanner />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/RewardSystem",
      //   element: (
      //     <ProtectedRoute permissionKey="RewardSystem">
      //       <RewardSystem />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/GiftCard",
        element: (
          <ProtectedRoute permissionKey="GiftCard">
            <GiftCard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/GiftCardUser",
        element: (
          <ProtectedRoute permissionKey="GiftCardUser">
            <GiftCardUser />
          </ProtectedRoute>
        ),
      },
      {
        path: "/Policy",
        element: (
          <ProtectedRoute permissionKey="Policy">
            <Policy />
          </ProtectedRoute>
        ),
      },
      {
        path: "/Faq",
        element: (
          <ProtectedRoute permissionKey="Faq">
            <Faq />
          </ProtectedRoute>
        ),
      },
      {
        path: "/Dsr",
        element: (
          <ProtectedRoute permissionKey="Dsr">
            <Dsr />
          </ProtectedRoute>
        ),
      },
      {
        path: "/SalesTarget",
        element: (
          <ProtectedRoute permissionKey="SalesTarget">
            <SalesTarget />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/GST",
      //   element: (
      //     <ProtectedRoute permissionKey="GST">
      //       <Gst />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/user-profile/:id",
        element: <UserProfile />,
      },
      {
        path: "/MMTCBuyRequest",
        element: (
          <ProtectedRoute permissionKey="MMTCBuyRequest">
            <Mmtc_buy_request />
          </ProtectedRoute>
        ),
      },
      {
        path: "/MMTCBuyResponse",
        element: (
          <ProtectedRoute permissionKey="MMTCBuyResponse">
            <Mmtc_buy_response />
          </ProtectedRoute>
        ),
      },
      {
        path: "/MMTCSellRequest",
        element: (
          <ProtectedRoute permissionKey="MMTCSellRequest">
            <MmtcSellRequest />
          </ProtectedRoute>
        ),
      },
      {
        path: "/MMTCSellResponse",
        element: (
          <ProtectedRoute permissionKey="MMTCSellResponse">
            <MmtcSellResponse />
          </ProtectedRoute>
        ),
      },
      {
        path: "/MMTCRedeems",
        element: (
          <ProtectedRoute permissionKey="MMTCRedeems">
            <Mmtc_redeem />
          </ProtectedRoute>
        ),
      },
      {
        path: "/sell-quote",
        element: (
          <ProtectedRoute permissionKey="mmtcSellQuote">
            <SellQuoteMmtc />
          </ProtectedRoute>
        ),
      },

      {
        path: "/tradefailed",
        element: (
          <ProtectedRoute permissionKey="tradefailed">
            {/* <SellQuoteMmtc /> */}
            <TradeFailed />
          </ProtectedRoute>
        ),
      },

      {
        path: "/report",
        element: (
          <ProtectedRoute permissionKey="sendReport">
            <SendRepo />
          </ProtectedRoute>
        ),
      },

      {
        path: "/kycnamemismatch",
        element: (
          <ProtectedRoute permissionKey="kycmismatch">
            <Kycnamemismatch />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/login",
    element: (
      <RequireNoAuth>
        <Login />
      </RequireNoAuth>
    ),
  },
]);
